export const tags = [
    'PatientAge',
    'PatientSize',
    'PatientSex',
    'PatientWeight',
];
